// React imports.
import React from "react";

import { Assessment2StepsEnum } from "../state";
import { Assessment2FuelStatusEnum } from "../state";


const Assessment2BottomText = ({state, fuelType }) => (
    <div>
          {(fuelType.numTotalVendors === 0)
          &&<span>
                Please click ”Next to continue.
            </span>
          }

          {((fuelType.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.OverMinNoIssues
            ||fuelType.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.UnderMinNoIssues)
            &&(fuelType.viewAnyway != true)
            && (fuelType.numTotalVendors !== 0))
          &&<span>
                No further action is required for {fuelType.descriptionHeat}  households in Assessment #2.
                If you want to analyze potential data reliability issues for {fuelType.descriptionHeating}  data anyway,
                click&nbsp;
                <button className="dataButton"
                      onClick={(changeEvent) => state.assessment2ViewAnyway(changeEvent, fuelType)}>
                      here
                  </button>
                .&nbsp; Otherwise, click next.

            </span>
          }
          {((fuelType.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.OverMinNotEnoughRequested
            ||fuelType.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.OverMinNotEnoughReceived
            ||fuelType.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.UnderMinNotEnoughRequested
            ||fuelType.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.UnderMinNotEnoughReceived)
            && (fuelType.numTotalVendors !== 0))
          &&<span>
                There are several factors that could be contributing to this potential data reliability issue.
                Answer the follow-up questions below to investigate further. 
            </span>
          }
          {(fuelType.viewAnyway === true)
          &&<span>
                Answer the follow-up questions below to investigate further. 
            </span>
          }
    </div>
);

export default Assessment2BottomText;
